import React from 'react'
import { TypeChatBotProps } from './types'

type Props = TypeChatBotProps & {
  expand?: boolean,
}

const useStyleChatBotAlert = ({ expand, theme = 'default' }: Props) => {

  const bubbleColor = 'white'
  const themes = {
    default: {
      bgColor: '#F4F7FF',
      shadowColor: '#e0e5f2',
      shadowColorBoxChat: '#BACAF2',
    },
    yellow: {
      bgColor: '#fffae8',
      shadowColor: '#fef5d3',
      shadowColorBoxChat: '#2626263d',
    }
  }
  const selectedTheme:{bgColor: string, shadowColor: string, shadowColorBoxChat:string} = themes[theme as keyof object]

  return {
    main: {
      mb: 4,
      boxShadow: `inset 0 0 10px ${selectedTheme.shadowColor}`,
      background: selectedTheme.bgColor,
      borderRadius: "12px",
      height: expand ? 1 : '110px',
      overflow: 'hidden',
      transition: 'all 1s ease-in-out',
      boxSizing: 'border-box',
      border: `1px solid ${selectedTheme.bgColor}`,
      width: '100%', // Changed from 'fit-content' to 100%
    },
    container: {
      boxSizing: 'border-box',
      p: 2,
      gap: 1,
      flexDirection: 'row',
      justifyContent: 'flex-start', // Changed from space-between
      alignItems: 'flex-start',
    },
    text: {
      textAlign: 'left',
      color: '#1B316C',
    },
    textLink: {
      textAlign: 'left',
      color: '#3a6ced',
    },
    textSubtitle: {
      textAlign: 'right',
      color: '#1b316c8c',
      width: 'auto',
      minWidth: '100px',
    },
    chatLog: {
      gap: 2,
      mb: '5rem',
    },
    content: {
      ml: 2,
      maxWidth: '700px',
      "& .talk-bubble": {
        display: "inline-block",
        position: "relative",
        height: "auto",
        background: bubbleColor,
        boxShadow: `0px 4px 4px ${selectedTheme.shadowColorBoxChat}`,
        borderRadius: "12px",
        px: 2,
        py: 2,
      },
      "& .tri-right.border.left-top:before": {
        content: "' '",
        position: "absolute",
        width: "0",
        height: "0",
        left: "-40px",
        right: "auto",
        top: "-8px",
        bottom: "auto",
        border: "32px solid",
        borderColor: "#666 transparent transparent transparent"
      },
      "& .tri-right.left-top:after": {
        content: "' '",
        position: "absolute",
        width: "0",
        height: "0",
        left: "-20px",
        right: "auto",
        top: "0px",
        bottom: "auto",
        border: "22px solid",
        borderColor: `${bubbleColor} transparent transparent transparent`
      },
      "& .tri-right.border.left-in:before": {
        content: "' '",
        position: "absolute",
        width: "0",
        height: "0",
        left: "-40px",
        right: "auto",
        top: "30px",
        bottom: "auto",
        border: "20px solid",
        borderColor: "#666 #666 transparent transparent"
      },
      "& .tri-right.left-in:after": {
        content: "' '",
        position: "absolute",
        width: "0",
        height: "0",
        left: "-20px",
        right: "auto",
        top: "38px",
        bottom: "auto",
        border: "12px solid",
        borderColor: `${bubbleColor} ${bubbleColor} transparent transparent`
      }
    },
    expand: {
      mt: 1,
      alignSelf: 'flex-start',
    }
  }

}

export default useStyleChatBotAlert
